(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    window.whenSwiperReady(function () {
        var brandsGrid = document.querySelector('.brands-grid');
        if (!brandsGrid || brandsGrid.classList.contains('swiper-initialized')) return;

        new Swiper('.brands-grid', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheel: {
                forceToAxis: true,
            },
            scrollbar: {
                el: '.brands-grid .swiper-scrollbar',
                hide: true,
            },
            navigation: {
                nextEl: '.brands-grid .swiper-button-next',
                prevEl: '.brands-grid .swiper-button-prev',
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    window.whenSwiperReady(function () {
      var featuredCollection = document.querySelector('.featured-collection-sw-wrap');
      if (!featuredCollection || featuredCollection.classList.contains('swiper-initialized')) return;

      new Swiper('.featured-collection-sw-wrap', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        mousewheel: {
          forceToAxis: true,
        },
        scrollbar: {
          el: '.featured-collection-sw-wrap .swiper-scrollbar',
          hide: true,
        },
        navigation: {
          nextEl: '.featured-collection-sw-wrap .swiper-button-next',
          prevEl: '.featured-collection-sw-wrap .swiper-button-prev',
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    

function initAccordion(accordionEl) {
var title = accordionEl.querySelector('[data-title]');
var content = accordionEl.querySelector('[data-content]');
var isOpen = false;
var height = 0;

close();


title.addEventListener('click', handleClick);
content.addEventListener('transitionend', handleTransition);

function handleClick() {
height = content.scrollHeight;
if (isOpen) {
close();
} else {
open();
}
}

function close() {
isOpen = false;
accordionEl.classList.remove('is-active');
content.style.maxHeight = height + 'px';

setTimeout(function () {
content.style.maxHeight = '0px';
}, 1);
}

function open() {
isOpen = true;
accordionEl.classList.add('is-active');
accordionEl.classList.remove('is-hidden');
content.style.maxHeight = '0px';

setTimeout(function () {
content.style.maxHeight = height + 'px';
}, 1);
}

function handleTransition() {
if (!isOpen) {
accordionEl.classList.add('is-hidden');
}
content.style.maxHeight = '';
}
}

document.querySelectorAll('[data-accordion]').forEach(function (el) {
initAccordion(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky =
this.getAttribute('data-sticky-type') === 'always' ||
this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
}

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach((disclosure) => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

// Custom mega menu on hover

document.addEventListener('DOMContentLoaded', () => {
const megaMenus = document.querySelectorAll('.mega-menu');

megaMenus.forEach((menu) => {
const summary = menu.querySelector('summary');
let closeTimeout;


summary.addEventListener('click', (e) => e.preventDefault());


menu.addEventListener('mouseenter', () => {
clearTimeout(closeTimeout);
menu.setAttribute('open', true);
});


menu.addEventListener('mouseleave', () => {
closeTimeout = setTimeout(() => {
menu.removeAttribute('open');
}, 200);
});
});

// Sidebar navigation
const toggles = document.querySelectorAll('.sidebar-toggle');

toggles.forEach(toggle => {
const submenu = toggle.nextElementSibling;

toggle.addEventListener('click', () => {
const isOpen = submenu.classList.contains('show');


document.querySelectorAll('.sidebar-submenu.show').forEach(openSub => {
slideUp(openSub);
openSub.previousElementSibling.classList.remove('active');
});

if (!isOpen) {
toggle.classList.add('active');
slideDown(submenu);
} else {
toggle.classList.remove('active');
slideUp(submenu);
}
});
});

function slideDown(element) {
element.classList.add('show');
element.style.maxHeight = element.scrollHeight + 'px';
}

function slideUp(element) {
element.style.maxHeight = element.scrollHeight + 'px';
requestAnimationFrame(() => {
element.style.maxHeight = '0';
});
element.addEventListener('transitionend', function handler() {
element.classList.remove('show');
element.removeEventListener('transitionend', handler);
});
}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  window.whenSwiperReady(function () {
    const heroSliderElement = document.querySelector('.hero-slider-main-wrap');
    if (!heroSliderElement || heroSliderElement.classList.contains('swiper-initialized')) return;

    const loadDeferredAssets = (slide) => {
      if (!slide) return;

      slide.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => {
        if (img.dataset.src && img.getAttribute('src') !== img.dataset.src) {
          img.setAttribute('src', img.dataset.src);
        }

        if (img.dataset.srcset) {
          img.setAttribute('srcset', img.dataset.srcset);
        }

        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };

    const heroSwiper = new Swiper('.hero-slider-main-wrap', {
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: window.matchMedia('(min-width: 990px)').matches,
      autoplay: window.matchMedia('(min-width: 990px)').matches
        ? {
            delay: 5000,
            disableOnInteraction: false,
          }
        : false,
      navigation: {
        nextEl: '.hero-slider-main-wrap .swiper-button-next',
        prevEl: '.hero-slider-main-wrap .swiper-button-prev',
      },
      speed: 1000,
      allowTouchMove: true,
      on: {
        init(swiper) {
          loadDeferredAssets(swiper.slides[swiper.activeIndex]);
          loadDeferredAssets(swiper.slides[swiper.activeIndex + 1]);
        },
        slideChangeTransitionStart(swiper) {
          loadDeferredAssets(swiper.slides[swiper.activeIndex]);
          loadDeferredAssets(swiper.slides[swiper.activeIndex + 1]);
          loadDeferredAssets(swiper.slides[swiper.activeIndex - 1]);
        }
      }
    });

    loadDeferredAssets(heroSwiper.slides[heroSwiper.activeIndex]);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const slidePageDownButtons = document.querySelectorAll('.slide-page-down');
    const heroSection = document.querySelector('.hero-slider-main-wrap');
    const header = document.querySelector('header');

    if (slidePageDownButtons.length > 0 && heroSection) {
      slidePageDownButtons.forEach(function(slidePageDown) {
        slidePageDown.addEventListener('click', function (e) {
          e.preventDefault();

          const headerHeight = header ? header.offsetHeight : 0;

          const targetScroll = window.scrollY + heroSection.getBoundingClientRect().bottom - headerHeight;

          const start = window.scrollY;
          const distance = targetScroll - start;
          const duration = 700;
          let startTime = null;

          function animateScroll(currentTime) {
            if (!startTime) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);

            // easing (easeInOutCubic)
            const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;

            window.scrollTo(0, start + distance * ease);

            if (timeElapsed < duration) {
              requestAnimationFrame(animateScroll);
            }
          }

          requestAnimationFrame(animateScroll);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const parallaxElements = document.querySelectorAll('[data-speed]');

    if (parallaxElements.length > 0) {
      // Function to detect if device is mobile
      const isMobileDevice = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
        const isMobileByUserAgent = mobileRegex.test(userAgent.toLowerCase());
        const isMobileByWidth = window.innerWidth <= 749;
        const isMobileByTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Consider it mobile if it matches user agent OR (small width AND touch capability)
        return isMobileByUserAgent || (isMobileByWidth && isMobileByTouch);
      };

      const parallaxHandler = () => {
        const windowTop = window.scrollY;
        const isMobile = isMobileDevice();

        parallaxElements.forEach((currentElement) => {
          const elementRect = currentElement.getBoundingClientRect();
          const elementTop = elementRect.top + windowTop;
          const elementHeight = elementRect.height;
          const viewPortHeight = window.innerHeight;

          // Check if the element is in the viewport
          if (elementRect.top < viewPortHeight && elementRect.bottom > 0) {
            const scrolled = windowTop - elementTop + viewPortHeight / 2 - elementHeight / 2;
            const speed = parseFloat(currentElement.dataset.speed) || 0.07;

            // Check device type and use appropriate transform attribute
            let additionalTransform = '';
            if (isMobile) {
              additionalTransform = currentElement.dataset.mTransform || '';
            } else {
              additionalTransform = currentElement.dataset.transform || '';
            }

            let transformValue = `translateY(${scrolled * -speed}px)`;
            if (additionalTransform && additionalTransform !== '0') {
              transformValue += ` ${additionalTransform}`;
            }

            currentElement.style.transform = transformValue;
          }
        });
      };

      // Throttle function to limit resize events
      let resizeTimeout;
      const throttledResizeHandler = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          window.requestAnimationFrame(parallaxHandler);
        }, 100);
      };

      window.addEventListener('scroll', () => {
        window.requestAnimationFrame(parallaxHandler);
      });

      // Handle window resize with throttling
      window.addEventListener('resize', throttledResizeHandler);

      // Handle orientation change on mobile devices
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          window.requestAnimationFrame(parallaxHandler);
        }, 300);
      });

      // Initial call to set positions
      window.requestAnimationFrame(parallaxHandler);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    window.whenSwiperReady(function () {
      const insta_wrapper = document.querySelector('.insta-carousel .swiper-wrapper');
      const insta_slides = insta_wrapper ? insta_wrapper.querySelectorAll('.swiper-slide').length : 0;
      const instaCarousel = document.querySelector('.insta-carousel');

      if (!instaCarousel || instaCarousel.classList.contains('swiper-initialized')) return;

      new Swiper('.insta-carousel', {
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        speed: 5000,
        grabCursor: false,
        freeModeMomentum: false,
        loopedSlides: insta_slides,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
function initFeaturedCollectionSwiper(container) {
  if (!container || container.classList.contains('swiper-initialized')) return;

  window.whenSwiperReady(function () {
    if (container.classList.contains('swiper-initialized')) return;

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: container.querySelector('.swiper-scrollbar'),
        hide: true,
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
    });

    container.classList.add('swiper-initialized');
  });
}

// Observe and initialize
const observer = new MutationObserver(() => {
  document.querySelectorAll('#product-recommendations-slider:not(.swiper-initialized)').forEach((container) => {
    initFeaturedCollectionSwiper(container);
  });
});

// Start observing DOM changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Also init immediately on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('#product-recommendations-slider:not(.swiper-initialized)').forEach((container) => {
    initFeaturedCollectionSwiper(container);
  });
});

  } catch(e) { console.error(e); }
})();
})();
